<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Title Page">
<div class="full" id="title"><span class="right_1" epub:type="pagebreak" id="page_i" title="i"><span class="right_1" epub:type="pagebreak" id="page_ii" title="ii"><span class="right_1" epub:type="pagebreak" id="page_iii" title="iii"><a href="#/text/9780063079441_Contents#rtitle"><img alt="image" src="images/Titlepage.jpg"/></a></span></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063079441_Titlepage.vue?1432d82e